import type { CSSProperties, ReactNode } from "react";
import { EJINSIGHT_COLORS, EJINSIGHT_TYPE } from "@/lib/theme/ejinsight";

type EyebrowProps = {
  children: ReactNode;
  size?: "sm" | "lg";
  tone?: "primary" | "accent" | "ink" | "onDark";
  withDash?: boolean;
  className?: string;
  style?: CSSProperties;
};

const TONE_MAP = {
  primary: EJINSIGHT_COLORS.primary,
  // "accent" semantically maps to the dark logo teal — provides contrast
  // within a single-hue palette without introducing a foreign color.
  accent: EJINSIGHT_COLORS.ink,
  ink: EJINSIGHT_COLORS.ink,
  onDark: EJINSIGHT_COLORS.textOnDark,
} as const;

export function Eyebrow({
  children,
  size = "sm",
  tone = "primary",
  withDash = false,
  className,
  style,
}: EyebrowProps) {
  const recipe = size === "lg" ? EJINSIGHT_TYPE.eyebrowLg : EJINSIGHT_TYPE.eyebrow;
  const color = TONE_MAP[tone];

  return (
    <span
      className={`inline-flex items-center gap-3 ${className ?? ""}`}
      style={{ ...recipe, color, ...style }}
    >
      {withDash && (
        <span
          aria-hidden
          className="inline-block h-px w-8"
          style={{ backgroundColor: color }}
        />
      )}
      {children}
    </span>
  );
}
